import React, { useState } from "react";
import { X, Loader2, BellRing } from "lucide-react";
import { useApp } from "../context/AppContext";
import { TX } from "../data";
import { IMAGES, PRODUCTS } from "../mock";
import { joinWaitlist } from "../lib/api";
import { useToast } from "../hooks/use-toast";

const WaitlistModal = () => {
  const { lang, waitlistOpen, setWaitlistOpen, waitlistProductId } = useApp();
  const tx = TX[lang];
  const { toast } = useToast();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email || busy) return;
    setBusy(true);
    try {
      const res = await joinWaitlist(email, waitlistProductId || "copper-peptide-serum-30ml");
      toast({
        title: "LÉLUNE",
        description: res.status === "already_joined" ? tx.waitlistDup : tx.waitlistOk,
      });
      setEmail("");
      setWaitlistOpen(false);
    } catch {
      toast({ title: "LÉLUNE", description: lang === "nl" ? "Er ging iets mis." : "Something went wrong." });
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <div
        className={`fixed inset-0 z-[60] bg-[#2A201C]/50 backdrop-blur-sm transition-opacity duration-300 ${
          waitlistOpen ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
        onClick={() => setWaitlistOpen(false)}
      />
      <div
        className={`fixed z-[61] left-1/2 top-1/2 w-[calc(100%-2.5rem)] max-w-md -translate-x-1/2 -translate-y-1/2 transition-all duration-400 ${
          waitlistOpen ? "opacity-100 scale-100" : "opacity-0 scale-95 pointer-events-none"
        }`}
        style={{ transitionTimingFunction: "cubic-bezier(0.16,1,0.3,1)" }}
      >
        <div className="relative bg-[#FBF5F0] rounded-3xl border border-[#EEE0D7] overflow-hidden shadow-2xl">
          <button
            onClick={() => setWaitlistOpen(false)}
            className="absolute top-4 right-4 z-10 text-[#8A756C] hover:text-[#B4715C]"
            aria-label="Close"
          >
            <X className="h-5 w-5" />
          </button>
          <div className="h-40 bg-gradient-to-br from-[#F3E0D6] to-[#E7C3B4] flex items-center justify-center">
            <img src={(PRODUCTS.find((p) => p.id === waitlistProductId) || {}).image || IMAGES.serum} alt="Product" className="h-full object-contain p-5" />
          </div>
          <div className="p-8">
            <div className="flex items-center gap-2 text-[#B4715C]">
              <BellRing className="h-4 w-4" />
              <span className="text-[11px] tracking-label uppercase">Pre-order</span>
            </div>
            <h3 className="mt-3 font-serif text-3xl text-[#3A2C28] leading-tight">{tx.waitlistTitle}</h3>
            <p className="mt-3 text-sm text-[#6E5A52] leading-relaxed">{tx.waitlistText}</p>
            <form onSubmit={submit} className="mt-6 space-y-3">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={tx.waitlistPlaceholder}
                className="w-full h-12 px-5 rounded-full border border-[#E0CDC2] bg-white text-sm focus:outline-none focus:border-[#B4715C]"
              />
              <button
                type="submit"
                disabled={busy}
                className="w-full h-12 rounded-full bg-[#3A2C28] text-white text-[11px] tracking-label uppercase hover:bg-[#B4715C] disabled:opacity-70 flex items-center justify-center gap-2"
              >
                {busy && <Loader2 className="h-4 w-4 animate-spin" />}
                {tx.waitlistBtn}
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default WaitlistModal;
